import {store} from '../../store';
import {showError} from '../../message/action/messageActions';
import ErrorCode from '../enums/ErrorCode';

export function setGlobalRequestInterceptor(httpClient) {
    httpClient.interceptors.request.use((request => {
            if (!request.immediate) {
                store.dispatch({type: 'SHOW_LOADER'});
            }
            const apiKey = window.sessionStorage.getItem('api-key');
            if (!!apiKey && apiKey !== 'undefined') {
                request.headers.Authorization = `Bearer ${apiKey}`;
            }
            return request;
        }
    ));
}

export function setGlobalResponseInterceptor(httpClient) {
    httpClient.interceptors.response.use(response => {
        store.dispatch({type: 'HIDE_LOADER'});
        if (response.data && !response.data.success && response.data.errorResponse) {
            const errorValue = Object.values(ErrorCode).find(value => value.code === response.data.errorCode);
            if (!errorValue || !errorValue.silent) {
                handleErrorMessage(response.data.errorResponse.errorCode);
            }
        }

        return response;
    }, (error) => {
        let requestError = null;
        store.dispatch({type: 'HIDE_LOADER'});
        if (error && error.response &&
            error.response.data &&
            error.response.data.errorResponse &&
            error.response.data.errorResponse.errorCode) {
            requestError = error.response.data.errorResponse.errorCode;
            const errorValue = Object.values(ErrorCode).find(value => value.code === requestError);
            console.log(errorValue);
            if (!errorValue || !errorValue.silent) {
                handleErrorMessage(requestError);
            }
        }
        return {
            data: {
                success: false
            },
            errorCode: requestError
        };
    });
}

function handleErrorMessage(errorCode) {
    const errorMessage = Object.keys(ErrorCode).find(code => ErrorCode[code].code === errorCode);
    if (errorMessage) {
        store.dispatch(showError(`Error.${errorMessage}`));
    } else {
        store.dispatch(showError('Error.GENERAL'));
    }
}
